import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr';
import en from './locales/en';
import es from './locales/es';
import ar from './locales/ar';

// Langues à écriture de droite à gauche (RTL).
const RTL_LANGS = ['ar'];

// Applique la direction du document selon la langue (RTL pour l'arabe).
const applyDirection = (lng) => {
  if (typeof document === 'undefined') return;
  const base = String(lng || 'fr').split('-')[0];
  const dir = RTL_LANGS.includes(base) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', base);
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr, en, es, ar },
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common', 'auth', 'validation', 'home', 'travels', 'payment', 'profile', 'admin', 'pages'],
    interpolation: { escapeValue: false },
    detection: {
      // 🇫🇷 Français par DÉFAUT (fallbackLng) sauf CHOIX EXPLICITE de l'utilisateur (localStorage).
      // On ne se base plus sur `navigator` : un navigateur en anglais ne doit pas basculer tout
      // le site (ni les dates) en anglais pour un utilisateur francophone (point 13 / G7).
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'gowele_lang',
    },
    react: { useSuspense: false },
  });

applyDirection(i18n.language);
i18n.on('languageChanged', applyDirection);

export default i18n;
